

export const mapAuto = normalizeNamespace((namespace, map) => {
  const res = {}
  normalizeMap(map).forEach(({ key, val }) => {
    const nsval = namespace + val
    res[key] = {

      get: function mapped () {
        let state = this.$store.state
        let getters = this.$store.getters
        if (namespace) {
          const module = getModuleByNamespace(this.$store, 'mapStateMutations', namespace)
          if (!module) {
            return
          }
          state = module.context.state
          getters = module.context.getters
        }

        if (nsval in this.$store.getters) {
          return this.$store.getters[nsval]
        }

        return typeof val === 'function'
          ? val.call(this, state, getters)
          : state[val]
      },

      set: function mappedMutation (...args) {
        let commit = this.$store.commit
        if (namespace) {
          const module = getModuleByNamespace(this.$store, 'mapStateMutations', namespace)
          if (!module) {
            return
          }
          commit = module.context.commit
        }
        return typeof val === 'function'
          ? val.apply(this, [commit].concat(args))
          : commit.apply(this.$store, [val].concat(args))
      },
    }
    // mark vuex getter for devtools
    res[key].vuex = true
  })
  return res
})

//

export const mapStateMutations = normalizeNamespace((namespace, states) => {
  const res = {}
  normalizeMap(states).forEach(({ key, val }) => {
    res[key] = {

      get: function mappedState () {
        let state = this.$store.state
        let getters = this.$store.getters
        if (namespace) {
          const module = getModuleByNamespace(this.$store, 'mapStateMutations', namespace)
          if (!module) {
            return
          }
          state = module.context.state
          getters = module.context.getters
        }
        return typeof val === 'function'
          ? val.call(this, state, getters)
          : state[val]
      },

      set: function mappedMutation (...args) {
        let commit = this.$store.commit
        if (namespace) {
          const module = getModuleByNamespace(this.$store, 'mapStateMutations', namespace)
          if (!module) {
            return
          }
          commit = module.context.commit
        }
        return typeof val === 'function'
          ? val.apply(this, [commit].concat(args))
          : commit.apply(this.$store, [val].concat(args))
      },
    }
    // mark vuex getter for devtools
    res[key].vuex = true
  })
  return res
})

export const mapGetterMutations = normalizeNamespace((namespace, getters) => {
  const res = {}
  normalizeMap(getters).forEach(({ key, val }) => {
    const nsval = namespace + val
    res[key] = {

      get: function mappedGetter () {
        if (namespace && !getModuleByNamespace(this.$store, 'mapGetterMutations', namespace)) {
          return
        }
        if (process.env.NODE_ENV !== 'production' && !(nsval in this.$store.getters)) {
          console.error(`[vuex] unknown getter: ${nsval}`) // eslint-disable-line no-console
          return
        }
        return this.$store.getters[nsval]
      },

      set: function mappedMutation (...args) {
        let commit = this.$store.commit
        if (namespace) {
          const module = getModuleByNamespace(this.$store, 'mapGetterMutations', namespace)
          if (!module) {
            return
          }
          commit = module.context.commit
        }
        return typeof val === 'function'
          ? val.apply(this, [commit].concat(args))
          : commit.apply(this.$store, [val].concat(args))
      },
    }
    // mark vuex getter for devtools
    res[key].vuex = true
  })
  return res
})

//

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(key => ({ key, val: key }))
    : Object.keys(map).map(key => ({ key, val: map[key] }))
}

function normalizeNamespace (fn) {
  return (namespace, map) => {
    if (typeof namespace !== 'string') {
      map = namespace
      namespace = ''
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/'
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  const module = store._modulesNamespaceMap[namespace]
  if (process.env.NODE_ENV !== 'production' && !module) {
    console.error(`[vuex] module namespace not found in ${helper}(): ${namespace}`) // eslint-disable-line no-console
  }
  return module
}
